import {
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import {
  getDashboardDetails,
  getOnboarding,
  getTnC,
  updateOnboardingStep,
} from './api';
import { DashboardDetail, TermAndCondition } from './type';
import { getNextMilestone } from 'lib/utils';
import { captureUserActivity } from 'services/profile/api';
import { USER_ACTIVITY } from '../../types';
import useAuthStore from 'store/auth';

export const useGetTnC = (
  args?: Omit<
    UseQueryOptions<{ data: TermAndCondition[] }, Error, unknown>,
    'queryKey' | 'queryFn' | 'select'
  >
) => {
  return useQuery({
    queryKey: ['tnc'],
    queryFn: getTnC,
    select: ({ data }) => data?.[0],
    ...args,
  }) as UseQueryResult<TermAndCondition>;
};

type DashhboardDetailsArgs = Omit<
  UseQueryOptions<unknown, Error, unknown>,
  'queryKey' | 'queryFn'
> & {
  profileId: string;
};
export const useGetDashboardDetails = (args: DashhboardDetailsArgs) => {
  const { profileId, ...props } = args;
  return useQuery({
    queryKey: ['dashboard-flags', profileId],
    queryFn: () => getDashboardDetails(profileId),
    ...props,
  }) as UseQueryResult<DashboardDetail>;
};

export const usePostOnboardingStep = (
  args?: Omit<
    UseMutationOptions<unknown, Error, { milestone: string }, unknown>,
    'mutationFn' | 'onSuccess'
  >
) => {
  const setCurrentMilestone = useAuthStore.getState().setCurrentMilestone;
  const setOnBoarding = useAuthStore.getState().setOnBoarding;

  return useMutation({
    mutationFn: updateOnboardingStep,
    onSuccess: async (_, variables) => {
      captureUserActivity(USER_ACTIVITY.ONBOARDING_STEP, {
        milestone: variables.milestone,
      });

      const onboarding = await getOnboarding();
      setOnBoarding(onboarding?.data || []);

      const milestone = getNextMilestone();
      setCurrentMilestone(milestone?.name || 'completed');
    },
    ...args,
  });
};
